<div>
    <ion-grid>
        <ion-row>
            <ion-col size="6" class="individualRules" *ngFor="let rule of user.userRules">
                <ion-row>
                    <ion-col size="6">
                        <img [src]="getImageUrl('')" default=""/>
                        {{ rule.name }}
                    </ion-col>
                    <ion-col size="5">
                        {{ rule.cycleName }}
                    </ion-col>
                    <ion-col size="1">
                        <ion-icon
                                class="bp-delete"
                                (click)="confirmDeleteIndividualRule(rule)"
                        ></ion-icon>
                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>